import { c as _c } from "react/compiler-runtime";
import { PowerBIAnalytics, PremiumAnalyticsPages } from "@components/analytics/power-bi/power-bi-analytics";

/** Renders groups analytics under groups tab in analytics page*/
export function GroupsAnalytics() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PowerBIAnalytics pageDisplayName={PremiumAnalyticsPages.groups} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}